
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.999 7.286A6.995 6.995 0 017 14a7.013 7.013 0 01-4.954-2.05A7.001 7.001 0 010 7.286h2.206a4.794 4.794 0 002.955 4.147 4.807 4.807 0 006.275-2.597 4.792 4.792 0 00.355-1.55h2.207zM2.653 4.96c-.235.501-.38 1.038-.433 1.586H.01a6.993 6.993 0 01.648-2.52l1.995.935zM6.696 2.212a4.806 4.806 0 00-3.758 2.227L1.075 3.265A7.004 7.004 0 016.696.009v2.203zM7.467.018a7.011 7.011 0 014.487 2.032 7.001 7.001 0 012.035 4.496h-2.21a4.792 4.792 0 00-4.312-4.321V.018z","fill":"#18CDCA"}}),_c('ellipse',{attrs:{"cx":"4.713","cy":"5.719","rx":".828","ry":".827","fill":"#18CDCA"}}),_c('ellipse',{attrs:{"cx":"9.414","cy":"5.719","rx":".828","ry":".827","fill":"#18CDCA"}})])
          )
        }
      }
    